import type { CosmicBelowFoldKeyIngredientsType } from '@/lib/cms/cosmic/types/CosmicBelowFoldType'
import { cn } from '@/lib/utils'
import Image from 'next/image'
import React from 'react'

type Props = {
  keyIngredients?: CosmicBelowFoldKeyIngredientsType
}

export const ProductKeyIngredientsSection = ({ keyIngredients }: Props) => {
  if (
    !keyIngredients ||
    keyIngredients.hide ||
    !keyIngredients.items ||
    keyIngredients.items?.length === 0 ||
    // @ts-expect-error: Some times, some items in builder will return a `Default` object instead of the data
    // We do not need these defaults
    keyIngredients.items.Default
  ) {
    return null
  }

  return (
    <div
      style={{ backgroundColor: keyIngredients.backgroundColor }}
      className="px-5 py-24"
      data-test="product-key-ingredients-section"
    >
      <div className="flex flex-row items-center justify-center gap-4 pb-7 md:pb-24">
        <span
          className={cn(
            'text-4xl font-semibold',
            keyIngredients.title.titleTextColor
              ? `text-[${keyIngredients.title.titleTextColor}]`
              : 'text-primary',
          )}
          data-test="product-key-ingredients-section-title"
        >
          {keyIngredients.title.title}
        </span>

        <Image
          src={keyIngredients.title.titleAdornment}
          height={63}
          width={34}
          alt={keyIngredients.title.title}
        />
      </div>
      <ul
        className={`m-auto grid max-w-6xl list-disc grid-cols-1 justify-center gap-5 p-5 pt-0 ${
          keyIngredients.items.length === 1 ? 'px-[10%]' : 'md:grid-cols-2'
        }  md:gap-10`}
      >
        {keyIngredients.items.map((ingredient, index) => (
          <li
            key={`ingredient-${index}`}
            data-test={`product-key-ingredients-section-item-${index}`}
          >
            <div className="flex flex-col">
              <span className="text-2xl	font-semibold">{ingredient.title}</span>
              <span className="pt-2 text-[13px] leading-7 md:pt-4 md:text-base">
                {ingredient.description}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
